/**
 * @file ArchivePage ("/scr-weekly/archive") — Previous Challenges.
 *
 * Driven entirely from the archive index (single source of truth). Each card
 * lazily fetches its own manifest for details, so the index stays small and no
 * metadata is duplicated into it. Play-only: no leaderboard here.
 */

import { Link } from 'react-router-dom';
import { useArchiveIndex } from '../hooks/data';
import { PreviousChallengeCard } from '../components/PreviousChallengeCard';
import { LoadingState, ErrorState, EmptyState } from '../components/StateViews';
import { routes } from '../config/scrWeeklyConfig';

export function ArchivePage() {
  const { data: entries, loading, error, reload } = useArchiveIndex();

  return (
    <div className="scrw-challenge">
      <div className="scrw-back">
        <Link className="scrw-btn scrw-btn--ghost scrw-btn--sm" to={routes.current}>
          ← Back to this week’s challenge
        </Link>
      </div>

      <div className="scrw-page-head">
        <h1 className="scrw-page-head__title">Previous Challenges</h1>
        <p className="scrw-page-head__sub">
          Replay any past Sky City Rush weekly challenge. Play-only — leaderboards
          are only active during their week.
        </p>
      </div>

      {loading ? <LoadingState label="Loading previous challenges…" /> : null}

      {!loading && error ? (
        <ErrorState
          error={error}
          onRetry={reload}
          label="We couldn’t load previous challenges right now."
        />
      ) : null}

      {!loading && !error && entries && entries.length === 0 ? (
        <EmptyState label="No previous challenges yet — check back next week." />
      ) : null}

      {!loading && !error && entries && entries.length > 0 ? (
        <div className="scrw-grid">
          {entries.map((entry) => (
            <PreviousChallengeCard
              key={entry.id || `${entry.season}-${entry.week}`}
              entry={entry}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
